import React from "react";
import "../Navigation/css/NavBar.scss";

export default function SupportedHTTPMethods() {
    return (
        <div>
            Supported HTTP Methods
        </div>
    )
}